import { AnimatePresence, motion } from "framer-motion";

interface ModalErrorSummaryProps {
  errors: (string | undefined | null | false)[];
}

export const ModalErrorSummary = ({ errors }: ModalErrorSummaryProps) => {
  const visible = errors.filter((e): e is string => Boolean(e));

  return (
    <AnimatePresence initial={false}>
      {visible.length > 0 && (
        <motion.div
          key="modal-error-summary"
          className="w-full overflow-hidden"
          initial={{ opacity: 0, height: 0, marginTop: 0 }}
          animate={{ opacity: 1, height: "auto", marginTop: 12 }}
          exit={{ opacity: 0, height: 0, marginTop: 0 }}
          transition={{ duration: 0.15 }}
          role="alert"
          aria-live="polite"
        >
          {visible.length === 1 ? (
            <p className="font-error body-3-regular">{visible[0]}</p>
          ) : (
            <ul className="font-error body-3-regular list-disc pl-4 space-y-1">
              {visible.map((msg, i) => (
                <li key={i}>{msg}</li>
              ))}
            </ul>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  );
};
